/* eslint-disable bsky-internal/avoid-unwrapped-text */
import {useQueryClient} from '@tanstack/react-query'

import {WIDENTITY_DEEP_LINK} from '#/lib/constants'
import {Button, ButtonText} from '#/components/Button'
import {AccentLink, BodyText, Heading} from '#/wsocial/components/primitives'
import {IllustrationScanSuccessful} from './illustrations'
import {IllustrationArea, PageShell, SupportFooter} from './primitives'

export function StepVerifyingMobile({
  onSkip,
  allowSkip = true,
}: {
  onSkip: () => void
  allowSkip?: boolean
}) {
  return (
    <PageShell>
      <IllustrationArea>
        <IllustrationScanSuccessful />
      </IllustrationArea>

      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          gap: 8,
          padding: '24px 16px',
          textAlign: 'center',
        }}>
        <Heading>Open W Identity</Heading>
        <BodyText>
          Complete the verification to automatically continue.
        </BodyText>
        <AccentLink href={WIDENTITY_DEEP_LINK}>Open W Identity app</AccentLink>
      </div>

      {allowSkip && (
        <div style={{padding: '16px 16px'}}>
          <Button
            label="Explore W without verifying"
            color="secondary"
            size="large"
            testID="skipBtn"
            onPress={onSkip}
            style={{width: '100%'}}>
            <ButtonText>Explore W without verifying</ButtonText>
          </Button>
        </div>
      )}
      <SupportFooter />
    </PageShell>
  )
}
